import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import authData from "../../services/authData";
import { axiosVal as axios } from "..";

const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    progress: false,
    games: [],
    user: {
        
    },
    userAccount: {
        
    },
    searchResults: [],
    accountUpdated: false,
    accountDeleted: false,
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    },
};

const getToken = () => "LiveBearer "+localStorage.getItem('auth-token');

export const getGames = createAsyncThunk('games/get', async() => {
   
    try {
        const response = await axios.get(
            "/games/",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
       
        return response.data;
    }
    catch(error) {
        throw error.response.data;
    }
})

export const getGameDetails = createAsyncThunk('dealers/getGameDetails', async (id) => {
      try {
        const response = await axios.get(
          `/games/${id}`, // Use the dynamic `id` in the route
          {
            headers: {
              'x-auth': getToken(), // Attach the token in the headers
            },
          }
        );
        
        return response.data;
      } 
      catch (error) {
        throw error.response?.data || error.message; // Handle error gracefully
      }
});

export const updateGameDetails = createAsyncThunk(
    'dealers/updateGameDetails', 
    async ({ gameId, updatedData }) => {
      
      try {
        const response = await axios.put(
          `/games/${gameId}`,
          updatedData,
          {
            headers: {
              'x-auth': getToken(),
            },
          }
        );
        return response.data; 
      } catch (error) {
        throw error.response?.data || error.message; 
      }
    }
  );

export const deleteGame = createAsyncThunk(
    "dealers/deleteGame",
    async (gameId, { rejectWithValue }) => {
      try {
        await axios.delete(`/games/${gameId}`,
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return gameId; // Return the deleted dealer ID to update the state
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
);


const gamesSlice = createSlice({
    name: "counter",
    initialState,
    reducers: {
        reset(state, action) {
            state.error.status = false;
            state.success.status = false;
        },

    },
    extraReducers: (builder) => {

        builder.addCase(getGames.fulfilled, (state, action) => {
            state.games = action?.payload;
        }) 
        builder.addCase(getGameDetails.fulfilled, (state, action) => {
            state.dealerDetails = action?.payload;
        })
        builder.addCase(updateGameDetails.fulfilled, (state, action) => {
            state.dealerDetails = action?.payload;
            state.success.status = true;
            state.error.status = false;
            state.success.message = 'Game details updated successfully';
        });
        builder.addCase(updateGameDetails.pending, (state, action) => {
            state.success.status = false;
            state.error.status = false;
        });
        builder.addCase(updateGameDetails.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.error.message;
        });
        builder
        .addCase(deleteGame.fulfilled, (state, action) => {
            state.success.status = true;
            state.success.message = "Game deleted successfully!";
            state.dealerList = state.dealerList?.filter(dealer => dealer.id !== action.payload);
            })
        .addCase(deleteGame.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.payload || "Failed to delete game.";
        })
    }
});

export const gameActions = gamesSlice.actions;
export const gameReducer = gamesSlice.reducer;